import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CustomerAddress, CustomerAddressCreate, CustomerAddressFilter } from '../data/customerAddress';

export function createCustomerAddressService(client: AxiosInstance) {
  return createCrudService<CustomerAddress, CustomerAddressCreate, CustomerAddressFilter>(
    client,
    '/crm/CustomerAddress',
    'id',
  );
}

export type CustomerAddressService = CrudService<CustomerAddress, CustomerAddressCreate, CustomerAddressFilter>;
